import { useGetUserNameWithFallback } from '@pba/react-utils';
import type { ContentObjectList } from 'models';
import { Modal, type ModalOptions } from 'ui';
import { ContentObjectRenderer } from '../../../content-object-renderer';

export type PinnedPostCardModalOptions = {
  item: ContentObjectList;
};

type P = {
  onCancel: () => void;
  options: ModalOptions<PinnedPostCardModalOptions>;
};

const PinnedPostCardModal = ({ onCancel, options }: P) => {
  const getUserNameWithFallback = useGetUserNameWithFallback();

  return (
    <Modal
      isOpened={options.isOpened}
      maskClosable={false}
      onCancel={onCancel}
      title={options.isOpened ? getUserNameWithFallback(options.item.author) : undefined}
      width="medium"
    >
      {options.isOpened ? (
        <Modal.HugContent>
          <ContentObjectRenderer forceCommentsOpen item={options.item} view="other" />
        </Modal.HugContent>
      ) : null}
    </Modal>
  );
};

export default PinnedPostCardModal;
